'use client';
import { SliderWrapper } from '@/components/shared/SliderWrapper';
import { SkeletonChild, SkeletonParent } from '@/components/ui/Skeleton/skeleton';

interface Props {
  lengthCards: number;
}

const DailyBonusSkeleton = ({ lengthCards }: Props) => {
  return (
    <SkeletonParent className="flex flex-col gap-4 lg:gap-3 lg:p-2.5 p-4 rounded-2xl">
      <SkeletonChild className="rounded-lg h-5 w-29.5 self-start" />

      <SliderWrapper className="px-4 -mx-4">
        <div className="flex min-w-max gap-2 lg:gap-1.5">
          {
            Array.from({ length: lengthCards }).map(
              (_, i) => (
                <SkeletonParent key={i}>
                  <SkeletonChild className="lg:w-22.5 lg:h-30.5 w-22.5 h-35.5 px-2 py-3 flex justify-between flex-col rounded-2xl gap-[0.813rem]">
                    <SkeletonChild className="rounded-full mx-auto size-12 shrink-0" />
                    <SkeletonChild className="h-4 w-full rounded-lg" />
                  </SkeletonChild>
                </SkeletonParent>
              ),
            )
          }
        </div>
      </SliderWrapper>

      <SkeletonChild className="h-4 self-center rounded-lg mx-3 w-full" />
    </SkeletonParent>
  );
};

export default DailyBonusSkeleton;
